import { useFilterValue } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useFilterValueText } from '../../../utils/helpers/filters'
import FilterLink from '../../../components/filter/FilterLink'
import FilterListItem from '../../../components/list/FilterListItem'
import GroupsFilterSideModal from './GroupsFilterSideModal'

const GroupsFilter = ({ label, field, icon, presentation, ...props }) => {
  const { t } = useTranslation('listGroups')
  const [open, setOpen] = React.useState(false)

  presentation = presentation || 'bar'
  label = label || t('group')
  field = field || 'groupIds'

  const selectedValue = useFilterValueText(field)
  const Link = presentation === 'bar' ? FilterLink : FilterListItem

  return (
    <>
      <Link
        icon={presentation === 'bar' && 'RiTeamLine'}
        label={label}
        value={selectedValue}
        onClick={() => setOpen(true)}
      />

      <GroupsFilterSideModal open={open} onClose={() => setOpen(false)} label={label} field={field} {...props} />
    </>
  )
}

export default GroupsFilter
